"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultOnBlur = function () { };
var defaultOnChange = function () { };
var defaultOnClick = function () { };
var defaultProps = {
    disabled: false,
    iconType: 'none',
    onBlur: defaultOnBlur,
    onChange: defaultOnChange,
    onClick: defaultOnClick,
    value: '',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map